const ProductWishlistComponent = (new ProductWishlist());

class WishlistDrawer extends HTMLElement {
  constructor() {
    super();

    this.count = document.querySelector('[data-wishlist-bubble]');
    this.iconBubble = document.querySelector('#wishlist-icon-bubble');
    this.clear = this.querySelector('[data-wishlist-clear]');
    this.items = this.querySelector('[data-wishlist-items]');
    this.itemsContent = this.querySelector('#WishlistDrawer-Items');
    this.sidebar = this.querySelector('#WishlistDrawer-Sidebar');
    this.inner = this.querySelector('#WishlistDrawer-Inner');
    this.overlay = this.querySelector('#WishlistDrawer-Overlay');
    this.iconClose = this.querySelector('#WishlistDrawer-Close');
    this.inRemove = true;
    this._clear();
    this._remove();
    this.onUpdate();
    

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay.addEventListener('click', this.close.bind(this));
    this.iconClose.addEventListener('click', this.close.bind(this));
    this.setHeaderWishlistIconAccessibility();
  }

  setHeaderWishlistIconAccessibility() {
    this.iconBubble.setAttribute('role', 'button');
    this.iconBubble.setAttribute('aria-haspopup', 'dialog');
    this.iconBubble.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(this.iconBubble);
    });
    this.iconBubble.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(this.iconBubble);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    this.classList.remove('invisible');
    this.overlay.classList.remove('opacity-0');
    this.overlay.classList.add('opacity-50');
    this.sidebar.classList.remove('translate-x-full');

    const scrollbarWidth = window.innerWidth - document.body.offsetWidth;
    document.body.classList.add('overflow-y-hidden');
    document.body.style.paddingRight = scrollbarWidth + 'px';
    document.querySelector('header').style.paddingRight = scrollbarWidth + 'px';

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.sidebar;
        const focusElement = this.inner || this.iconClose;
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    removeTrapFocus(this.activeElement);

    this.classList.add('invisible');
    this.overlay.classList.add('opacity-0');
    this.overlay.classList.remove('opacity-50');
    this.sidebar.classList.add('translate-x-full');

    document.body.classList.remove('overflow-y-hidden');
    document.body.style.paddingRight = 0;
    document.querySelector('header').style.paddingRight = 0;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onUpdate() {
    const onUpdate = (_ref) => {
      let {
          products
      } = _ref;
      if (products.length > 0 && this.inRemove) {
        this.classList.remove('is-empty');
        this.itemsContent.classList.add('is-loading');
        this.items.innerHTML = '';
        this._addProducts(products);
      }
      if (products.length == 0) {
        this.classList.add('is-empty');
        this.removeDisabled();
      }
      this.inRemove = true;
      this._updateCount(products.length);
    };

    onUpdate({
      products: ProductWishlistComponent.products
    });
    ProductWishlistComponent.runOnUpdate(onUpdate);
  }

  _updateCount(length) {
    this.count.innerHTML = length;
    length == 0 ? this.iconBubble.classList.add('is-empty') : this.iconBubble.classList.remove('is-empty');
  }

  _clear() {
    this.clear.addEventListener('click', () => {
      ProductWishlistComponent.removeAll()
    });
  }

  _remove() {
    this.addEventListener('click', event => {
      const remove = event.target.closest('[data-wishlist-item-remove]');
      if (remove) {
        event.preventDefault();
        this.inRemove = false;
        remove.closest('[data-wishlist-item]').remove();
        ProductWishlistComponent.remove(remove.dataset.wishlistHandle);
      }
    });
  }

  async _addProducts(products) { 
    for (let i in products) {
      await fetch(`/products/${products[i].handle}?view=wishlist-item`)
      .then(response => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.renderProductGrid(html.querySelector('[data-wishlist-item]'));
        if (i == products.length - 1) {
          this.itemsContent.classList.remove('is-loading');
          this.removeDisabled();
        }
      });
    }
  }

  removeDisabled() {
    document.querySelectorAll('product-card-wishlist').forEach((wishlist) => {
      wishlist.querySelector('a').removeAttribute('aria-disabled');
      wishlist.querySelector('a').classList.remove('is-loading');
      wishlist.querySelector('a').classList.remove('cursor-not-allowed');
    });
  }

  renderProductGrid(html) {
    if (html) this.items.appendChild(html);
  }
}

customElements.define('wishlist-drawer', WishlistDrawer);

class ProductCardWishlist extends HTMLElement {
  constructor() {
    super();

    this.action = this.querySelector('a');
    this.handle = this.action.dataset.wishlistHandle;
    this.add = this.action.dataset.add;
    this.added = this.action.dataset.added;
    this.drawer = document.querySelector('wishlist-drawer');
    this.action.addEventListener('click', this.onButtonClick.bind(this));
    this.onUpdate();
  }

  onUpdate() {
    const onUpdate = () => {
      if (ProductWishlistComponent.includes(this.handle)) {
        this.action.classList.add('is-added');
        this.action.title = this.added;
      } else {
        this.action.classList.remove('is-added');
        this.action.title = this.add;
      }
    };
    onUpdate();

    ProductWishlistComponent.runOnUpdate(onUpdate);
  }

  onButtonClick(event) {
    event.preventDefault();

    if (!this.handle) return;
    if (this.action.getAttribute('aria-disabled') === 'true') return;
    document.querySelectorAll('product-card-wishlist').forEach((wishlist) => {
      wishlist.querySelector('a').setAttribute('aria-disabled', true);
      wishlist.querySelector('a').classList.add('cursor-not-allowed');
    });
    this.action.classList.remove('cursor-not-allowed');
    this.action.classList.add('is-loading');

    if (this.action.classList.contains('is-added')) {
      // if (this.drawer && ) this.drawer.querySelector(`[data-wishlist-item='${this.handle}']`).remove();
      ProductWishlistComponent.remove(this.handle);
    } else {
      ProductWishlistComponent.add(this.handle);
    }
  }
}

customElements.define('product-card-wishlist', ProductCardWishlist);